// import start_background_logo from "../../images/logo8.png";
import start_background_logo from "../../images/dZen_1.png";
import React from "react";

class Start_Background extends React.Component {
    render() {
        return(
            <div className="start_background">
                <img className="start_background_logo" src={start_background_logo} alt="start_background" />
            </div>
        )
    }
}

export default Start_Background;
